<template>
<div class="bg-light-gray py-2 mt-2">
    <div class="container">
        <div class="row">
            <div class="col-12 d-flex">
                <b-breadcrumb class="mb-0 col-8" :items="crumbs"></b-breadcrumb>
                    <div class=" col-4 mb-0 breadcrumb d-flex justify-content-end">
                        <router-link :to="{name: 'Results', params: {hash: hash}}">
                            <strong>&lt; Back to journey options</strong>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            hash: this.$route.params.hash,
            crumbs: [
                {
                    text: 'Plan your journey',
                    to: { name: 'Home' },
                },
                {
                    text: 'Select journey option',
                    to: { name: 'Results' },
                },
                {
                    text: 'Journey details',
                    active: true,
                },
            ],
        }
    },
}

</script>
